import { render, staticRenderFns } from "./Searchs.vue?vue&type=template&id=5a58aea1&scoped=true&"
import script from "./Searchs.vue?vue&type=script&lang=js&"
export * from "./Searchs.vue?vue&type=script&lang=js&"
import style0 from "./Searchs.vue?vue&type=style&index=0&id=5a58aea1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a58aea1",
  null
  
)

export default component.exports